export const projects = {

  one: (params: { projectId: number }) =>
    ['get:projects', params] as const,


  tags: (params: { projectId: number }) =>
    ['get:projects/tags', params] as const,

  clips: (params: { projectId: number;[key: string]: unknown }) =>
    ['get:projects/clips', params] as const,

  transcripts: (params: { projectId: number }) =>
    ['get:project/transcripts', params] as const,

  files: {
    base: 'get:project/files',
    all: (params: { projectId: number;[key: string]: unknown }) =>
      [projects.files.base, params] as const,
  },

  filePreview: {
    base: (fileId: number) => `get:project/file/preview/${fileId}`,
    one: (params: { fileId: number; projectId: number }) =>
      [projects.filePreview.base(params.fileId), params] as const,
  },

  conferenceTags: {
    summaries: (params: { projectId: number;[key: string]: unknown }) =>
      ['get:projects/conference-tags/summaries', params] as const,
    summariesCitations: (params: { projectId: number;[key: string]: unknown }) =>
      ['get:projects/conference-tags/summaries/citations', params] as const,
    overview: (params: { projectId: number;[key: string]: unknown }) =>
      ['get:projects/conference-tags/overview', params] as const,
    export: (params: { projectId: number;[key: string]: unknown }) =>
      ['get:projects/conference-tags/export', params] as const,
  },

  surveys: (params: { projectId: number;[key: string]: unknown }) =>
    ['get:projects/surveys', params] as const,

  notes: (params: { projectId: number }) =>
    [`get:projects/${params.projectId}/notes`, params] as const,

  terms: (params: { projectId: number }) =>
    ['get-project-terms', params] as const,

  termHighlights: (params: { projectId: number; term: string }) =>
    ['get-project-term-highlights', params] as const,

  spellCheckSuggestions: (params: { projectId: number; term: string }) =>
    ['get-spell-check-suggestions', params] as const,

  taggedMomentsExport: (params: { projectId: number }) =>
    [`get:projects/tagged-moments/export`, params] as const,

  summaryCalls: (params: { projectId: number }) =>
    ['project-summary-calls', params] as const,

  segments: (params: { projectId: number }) =>
    ['get:projects/segments', params] as const,

  insightsExport: (params: { projectId: number;[key: string]: unknown }) =>
    ['project-insights-export', params] as const,

  groupTags: (params: { projectId: number }) =>
    ['get:group-tags', params] as const,

  tagSummaryVersions: (params: { projectId: number; tagId: number;[key: string]: unknown }) =>
    ['get:project:tag-summaries:versions', params] as const,

  availableWidgets: (params: { projectId: number }) =>
    ['available-widgets', params] as const,

  chartLibraryWidgets: (params: { projectId: number }) =>
    ['chart-library-widgets', params.projectId] as const,


  quantAnalysis: {
    items: (params: { projectId: number; quantAnalysisId: number; versionNumber?: number }) =>
      ['project-quant-analysis-items', params] as const,

    versions: (params: { projectId: number; quantAnalysisId: number }) =>
      ['project-quant-analysis-versions', params] as const,

    one: (params: { projectId: number; quantAnalysisId: number }) =>
      ['project-quant-analysis', params] as const,

    list: (params: { projectId: number }) =>
      ['project-quant-analysis-list', params] as const,

    directoryTree: (params: { projectId: number; quantAnalysisId: number; versionId?: number }) =>
      ['getQuantDirectoryTree', params] as const,
  },

};
